var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IntersectionType } from '@nestjs/mapped-types';
import { IsInt, IsNumber, IsOptional, IsString, IsUrl, Max, Min, MinLength, } from 'class-validator';
import { LinkDescriptorDto, WorkspaceDescriptorDto, AccountLikeDescriptorDto, WorkspaceWithLinkDescriptorDto, } from './shared.js';
export class GoogleLoginInputDto extends AccountLikeDescriptorDto {
    redirectUrl;
}
__decorate([
    IsUrl({ require_tld: false }),
    __metadata("design:type", String)
], GoogleLoginInputDto.prototype, "redirectUrl", void 0);
//
class ContragentDistributorIdDto {
    contragentDistributorId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], ContragentDistributorIdDto.prototype, "contragentDistributorId", void 0);
export class GetContractsInputDto extends IntersectionType(WorkspaceDescriptorDto, ContragentDistributorIdDto) {
}
export class GetActsInputDto extends IntersectionType(WorkspaceDescriptorDto, ContragentDistributorIdDto) {
}
export class GetInvoicesInputDto extends IntersectionType(WorkspaceDescriptorDto, ContragentDistributorIdDto) {
}
//
class OrdContragentIdDto {
    ordContragentId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], OrdContragentIdDto.prototype, "ordContragentId", void 0);
class DocumentRecordIdDto {
    documentRecordId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], DocumentRecordIdDto.prototype, "documentRecordId", void 0);
export class GenerateContractInputDto extends IntersectionType(LinkDescriptorDto, OrdContragentIdDto) {
}
export class DeleteContractInputDto extends IntersectionType(WorkspaceWithLinkDescriptorDto, OrdContragentIdDto, DocumentRecordIdDto) {
}
export class UpdateContractInputDto extends IntersectionType(LinkDescriptorDto, OrdContragentIdDto, DocumentRecordIdDto) {
}
export class UpdateContractNumberInputDto extends UpdateContractInputDto {
    contractNumber;
}
__decorate([
    IsString(),
    MinLength(1),
    __metadata("design:type", String)
], UpdateContractNumberInputDto.prototype, "contractNumber", void 0);
export class UpdateActNumberInputDto extends IntersectionType(LinkDescriptorDto, OrdContragentIdDto, DocumentRecordIdDto) {
    actNumber;
}
__decorate([
    IsString(),
    MinLength(1),
    __metadata("design:type", String)
], UpdateActNumberInputDto.prototype, "actNumber", void 0);
//
export class GenerateActInputDto extends IntersectionType(LinkDescriptorDto, OrdContragentIdDto) {
    contractId;
    customContractId;
    vatPercent;
}
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], GenerateActInputDto.prototype, "contractId", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], GenerateActInputDto.prototype, "customContractId", void 0);
__decorate([
    IsOptional(),
    IsNumber({
        allowNaN: false,
        allowInfinity: false,
    }),
    Min(-1),
    Max(22),
    __metadata("design:type", Number)
], GenerateActInputDto.prototype, "vatPercent", void 0);
//
class DraftContractIdDto {
    draftContractId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], DraftContractIdDto.prototype, "draftContractId", void 0);
export class UploadFinalContractInputDto extends IntersectionType(WorkspaceDescriptorDto, OrdContragentIdDto, DraftContractIdDto) {
}
export class UploadInvoiceInputDto extends IntersectionType(WorkspaceDescriptorDto, OrdContragentIdDto) {
    fileName;
    customContractId;
    draftContractId;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], UploadInvoiceInputDto.prototype, "fileName", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], UploadInvoiceInputDto.prototype, "customContractId", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], UploadInvoiceInputDto.prototype, "draftContractId", void 0);
export class UploadFinalActInputDto extends IntersectionType(WorkspaceDescriptorDto, OrdContragentIdDto) {
    draftActId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], UploadFinalActInputDto.prototype, "draftActId", void 0);
//# sourceMappingURL=drive-google.js.map